<template>
    <section class="section">
        <div class="section__header">
            <h3 class="section__title">{{ getTranslation('applications') }} - {{pagination.total}}</h3>
            <div class="section__controls">
                <div class="section__controls-group"></div>
            </div>
        </div>
        <div class="section__body">
            <table class="table-3 table-borderless">
                <thead class="table-3__head">
                    <tr class="table-3__row">
                        <td colspan="2" class="table-3__cell  table__hcell">
                            <div class="form__group">
                                <form method="get" @submit.prevent="fetchApplications">
                                    <div class="field-advanced">
                                        <div class="field-advanced__inner">
                                            <div class="field-advanced__field-wrap">
                                                <input v-model="filterForm.query" class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text" :placeholder="getTranslation('search')">
                                            </div>

                                            <div class="field-advanced__right">
                                                <button class="btn  btn--square  btn--main">
                                                    <svg class="btn__icon">
                                                        <use xlink:href="#icon__search" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </td>
                        <td colspan="2" class="table-3__cell  table__hcell">
                            <states-filter v-model="filterForm.stateId" :is-main="true" />
                        </td>
                        <td class="table-3__cell  table__hcell">
                            <div class="form__group">
                                <v-select
                                        :options="formOptions.contestTypes"
                                        :reduce="option=>option.id"
                                        label="title"
                                        :placeholder="getTranslation('selectFromList')"
                                        v-model="filterForm.contestType"
                                />
                            </div>
                        </td>
                        <td class="table-3__cell  table__hcell">
                            <div class="form__group">
                                <v-select
                                        :options="formOptions.statuses"
                                        :reduce="option=>option.id"
                                        label="title"
                                        :placeholder="getTranslation('selectFromList')"
                                        v-model="filterForm.status"
                                />
                            </div>
                        </td>
                        <td class="table-3__cell  table__hcell">
                            <div class="form__group">
                                <v-select
                                        :options="formOptions.resultStatuses"
                                        :reduce="option=>option.id"
                                        label="title"
                                        :placeholder="getTranslation('selectFromList')"
                                        v-model="filterForm.resultStatus"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr class="table-3__row">
                        <th class="table-3__cell  table__hcell" style="width: 0.1%;">#</th>
                        <th class="table-3__cell  table__hcell" style="width: 18%;">{{ getTranslation('title') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 18%;">{{ getTranslation('position') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 24%;">{{ getTranslation('state') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 15%;">{{ getTranslation('contestType') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 10%;">{{ getTranslation('status') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 8%;">{{ getTranslation('CANDIDATE_PASSED') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 0.2%;"></th>
                    </tr>
                </thead>
                <tbody class="table-3__body">
                    <tr v-for="application in  applications" v-bind:key="application.id" class="table-3__row">
                        <td class="table-3__cell">
                            {{ application.id }}
                        </td>
                        <td class="table-3__cell">
                            <router-link :to="{name:'api.application.get',params:{id:application.id}}"> {{ application.title }}</router-link>
                        </td>
                        <td class="table-3__cell">
                            {{ application.resource.title }}
                        </td>
                        <td class="table-3__cell">
                           <span v-if="application.resource.state">
                              {{ application.resource.state.name }}
                              <span v-if="application.resource.state.parent">
                                ,{{ application.resource.state.parent.name }}
                            </span>
                          </span>
                            <span v-else-if="application.resource.type.id===RESOURCE_NRK_ID">
                                {{ application.resource.type.title }}
                            </span>
                        </td>
                        <td class="table-3__cell">
                           {{ getTranslation(application.contestType) }}
                        </td>
                        <td class="table-3__cell">
                            <span class="text--bold" :class="{'text--success' : application.status==='NEW', 'text--danger' : application.status==='REJECTED','text--info':application.status==='CONFIRMED'}">
                                {{getTranslation('APPLICATION_'+application.status)}}
                            </span>
                        </td>
                        <td class="table-3__cell">

                            <TestingStatusCardComponent v-if="application.resultData" :testing-event-candidate="application.resultData" :is-icon="true" :testing-status="application.resultData.testingStatus" />
                            <span v-else-if="application.status==='CONFIRMED' && application.isFinished || application.isLate" class="text-warning text--bold">
                                {{ getTranslation('CANDIDATE_NOTCOME') }}
                            </span>
                          <span v-else-if="application.status==='CONFIRMED'" class="text-info text--bold">
                                {{ getTranslation('testingNotStartedYet') }}
                            </span>
                        </td>
                        <td class="table-3__cell">
                            <ActionsComponent :has-delete="false" :has-edit="false" :has-password="false"
                                              :options="{
                                    detailedResults: application.resultData && hasPermission('api.candidate.profile.detailedResults')
                                }" v-on:detailedResults="()=>{$router.push({name:'api.candidate.profile.detailedResults',params:{id:candidateId,appId:application.id}})}"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
            <pagination :pagination="pagination" @change="()=>{fetchApplications();this.$scrollTo('.section__title');}" v-model="filterForm.page"></pagination>
        </div>
    </section>
</template>

<script>
    import StatesFilter from "@/components/shared/StatesFilter";
    import TestingStatusCardComponent from "../../applications/components/TestingStatusCardComponent";

    export default {
        name: "CandidateApplications",
        components: { TestingStatusCardComponent, StatesFilter },
        props: {
            candidateId: {
                required: true
            },
            active: {
                required: false,
                default: false
            }
        },
        data() {
            return {
                applications: [],
                formOptions: {
                    types: [],
                    resourceTypes: [],
                    statuses: [],
                    resultStatuses: [],
                    creationTypes: [],
                    contestTypes: [],
                },
                filterForm: {},
                pagination: {
                    total: 0,
                    lastPage: '',
                    currentPage: ''
                },
                optionsFetched: false,
            }
        },
        watch: {
            'active'( val ) {
                if ( val ) {

                    this.fetchApplications();

                    if ( !this.optionsFetched )
                        this.fetchFormOptions();
                }
            },
            'filterForm.stateId'() {
                this.fetchApplications();
            },
            'filterForm.contestType'() {
                this.fetchApplications();
            },
            'filterForm.status'() {
                this.fetchApplications();
            },
            'filterForm.resultStatus'() {
                this.fetchApplications();
            }
        },
        created() {

            if ( this.active ) {
                this.fetchApplications();
                this.fetchFormOptions().then( () => {
                    this.optionsFetched = true;
                } );
            }

        },
        methods: {
            fetchApplications() {
                let params = this.cleanObject( this.filterForm );
                this.axios.get( this.$config.urls.candidate.applications.url.replace( ':id', this.candidateId ), { params: params } )
                    .then( response => {
                        this.applications = response.data.data.items;
                        this.pagination.currentPage = response.data.data.activePage;
                        this.pagination.total = response.data.data.totalItemsCount;
                        this.pagination.lastPage = response.data.data.pages;
                    } ).catch(()=>{});
            },
            fetchFormOptions() {
                return this.axios.get( this.$config.urls.application.fetchFormOptions.url )
                           .then( response => {
                               this.formOptions.types = this.objectToArray( response.data.data.types, true );
                               this.formOptions.resourceTypes = this.objectToArray( response.data.data.resources, true );
                               this.formOptions.statuses = this.objectToArray( response.data.data.statuses, false, true );
                               this.formOptions.creationTypes = this.objectToArray( response.data.data.creationTypes, false, true );
                               this.formOptions.contestTypes = this.objectToArray(response.data.data.contestTypes,true,true);

                               this.formOptions.resultStatuses = response.data.data.resultStatuses.map( item => {
                                   return {
                                       id: item,
                                       title: item === 'TESTING_CANCELLED' ? this.getTranslation( item ) : this.getTranslation( 'CANDIDATE_' + item )
                                   }
                               } )
                           } ).catch(()=>{});
            },
        }
    }
</script>

<style scoped>

</style>
